import { render, staticRenderFns } from "./VisitPrerequisites.vue?vue&type=template&id=716250b3&scoped=true&"
import script from "./VisitPrerequisites.vue?vue&type=script&lang=js&"
export * from "./VisitPrerequisites.vue?vue&type=script&lang=js&"
import style0 from "./VisitPrerequisites.vue?vue&type=style&index=0&id=716250b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716250b3",
  null
  
)

export default component.exports